import React, {useEffect} from "react";
import './Terms.css'
const TermsAndConditions = (props) => {

  const packInfoArray = [
      // {price: "2.10 AED/day", unsubCode: "UNSUB dtoonz to 4273"},
      {price: "8.40 AED/day", unsubCode: "UNSUB urdu to 4273"},
      // {price: "12.60 AED/week", unsubCode: "UNSUB wbindie to 4273"}
  ]

  // useEffect(() => {
  //   console.log("From MobileEntry > ", packInfoArray[props.pack]);
  // }, [props.pack]);

  return (
    <div className="terms_section">
      <div className="row">
        <div className="col-lg-12">
          <h4 className="head">Terms & Conditions</h4>
          <ul>
            <li>
              By proceeding, you are agreeing to Etisalat Terms &amp; Conditions
              and Privacy Policy (visit etisalat.ae)
            </li>
            <li>
              Enjoy <span className="freetr">24 hours</span> Free trial (The
              free trial is valid only for new subscribers)
            </li>
            <li>
              After free trial, charges are{" "} 
              <span className="dyprice">{packInfoArray[props.pack].price}</span>
               (incl. VAT)
            </li>
            <li>Paid subscription starts after free trial automatically</li>
            <li>
              No commitment, you can cancel your subscription at any time by
              sending <span className="unsubkey">{packInfoArray[props.pack].unsubCode}</span>

            </li>
            <li>
              For support, please contact info@urduflix.com
            </li>
            <li>
              Please make sure that your browser is not using any 3rd-party
              blocking technologies and you have a healthy internet connection
              for swift access to the content.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
